import { render } from "./PackageLogsList.vue?vue&type=template&id=4fa62b20&scoped=true"
import script from "./PackageLogsList.vue?vue&type=script&lang=js"
export * from "./PackageLogsList.vue?vue&type=script&lang=js"

import "./PackageLogsList.vue?vue&type=style&index=0&id=4fa62b20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa62b20"]])

export default __exports__